var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "dialog-container" },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: "图片剪裁",
                visible: _vm.visible,
                top: "10vh",
                width: "900px",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c("div", { staticClass: "cropper-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "cropper",
                    staticStyle: { "text-align": "center" },
                  },
                  [
                    _vm.visible
                      ? _c("vueCropper", {
                          ref: "cropper",
                          attrs: {
                            img: _vm.option.img,
                            "auto-crop": _vm.option.autoCrop,
                            "auto-crop-width": _vm.option.autoCropWidth,
                            "auto-crop-height": _vm.option.autoCropHeight,
                            "output-size": _vm.option.outputSize,
                            "output-type": _vm.option.outputType,
                            info: _vm.option.info,
                            "can-scale": _vm.option.canScale,
                            fixed: _vm.option.fixed,
                            "fixed-number": _vm.option.fixedNumber,
                            full: _vm.option.full,
                            "fixed-box": _vm.option.fixedBox,
                            "can-move": _vm.option.canMove,
                            "can-move-box": _vm.option.canMoveBox,
                            original: _vm.option.original,
                            "center-box": _vm.option.centerBox,
                            height: _vm.option.height,
                            "info-true": _vm.option.infoTrue,
                            "max-img-size": _vm.option.maxImgSize,
                            enlarge: _vm.option.enlarge,
                            mode: _vm.option.mode,
                          },
                          on: {
                            realTime: _vm.realTime,
                            "img-load": _vm.handleImgLoad,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              !_vm.fixed
                ? _c(
                    "div",
                    { staticClass: "m-t-10" },
                    [
                      _c("el-button", { on: { click: _vm.changeFree } }, [
                        _vm._v("自由裁剪"),
                      ]),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeFixed(3)
                            },
                          },
                        },
                        [_vm._v("1:1")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeFixed(1)
                            },
                          },
                        },
                        [_vm._v("4:3")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeFixed(2)
                            },
                          },
                        },
                        [_vm._v("3:4")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeFixed(4)
                            },
                          },
                        },
                        [_vm._v("3:2")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeFixed(5)
                            },
                          },
                        },
                        [_vm._v("2:3")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeFixed(6)
                            },
                          },
                        },
                        [_vm._v("16:9")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.changeFixed(7)
                            },
                          },
                        },
                        [_vm._v("9:16")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.visible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.finish },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }